import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { ColorPreview } from "../ColorPreview.js";
import { ActionOpacities } from "./ActionOpacities/ActionOpacities.js";
import { isKeyOfActionOpacity, usePalette } from "./usePalette.js";
function Palette() {
  const {
    palette,
    previewPalette,
    expanded,
    handleColorPaletteChange,
    handleColorPaletteReset,
    handleColorPropertyChange,
    handleColorPropertyReset,
    handleOnExpand,
    handleOnResetColor,
    createSetPaletteAsPrimary,
    createSetActionsOpacity
  } = usePalette();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.primary,
        color: palette.primary,
        expanded: expanded === "primary",
        id: "primary",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.secondary,
        color: palette.secondary,
        expanded: expanded === "secondary",
        id: "secondary",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("secondary")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.error,
        color: palette.error,
        expanded: expanded === "error",
        id: "error",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("error")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.warning,
        color: palette.warning,
        expanded: expanded === "warning",
        id: "warning",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("warning")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.info,
        color: palette.info,
        expanded: expanded === "info",
        id: "info",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("info")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.success,
        color: palette.success,
        expanded: expanded === "success",
        id: "success",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("success")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.accent,
        color: palette.accent,
        expanded: expanded === "accent",
        id: "accent",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("accent")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.errorNeutral,
        color: palette.errorNeutral,
        expanded: expanded === "errorNeutral",
        id: "errorNeutral",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("errorNeutral")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.warningNeutral,
        color: palette.warningNeutral,
        expanded: expanded === "warningNeutral",
        id: "warningNeutral",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("warningNeutral")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.infoNeutral,
        color: palette.infoNeutral,
        expanded: expanded === "infoNeutral",
        id: "infoNeutral",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("infoNeutral")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.successNeutral,
        color: palette.successNeutral,
        expanded: expanded === "successNeutral",
        id: "successNeutral",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("successNeutral")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.accentNeutral,
        color: palette.accentNeutral,
        expanded: expanded === "accentNeutral",
        id: "accentNeutral",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("accentNeutral")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.errorSoft,
        color: palette.errorSoft,
        expanded: expanded === "errorSoft",
        id: "errorSoft",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("errorSoft")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.warningSoft,
        color: palette.warningSoft,
        expanded: expanded === "warningSoft",
        id: "warningSoft",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("warningSoft")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.infoSoft,
        color: palette.infoSoft,
        expanded: expanded === "infoSoft",
        id: "infoSoft",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("infoSoft")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.successSoft,
        color: palette.successSoft,
        expanded: expanded === "successSoft",
        id: "successSoft",
        onChangeColor: handleColorPaletteChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPaletteReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("successSoft")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.accentSoft,
        color: palette.accentSoft,
        expanded: expanded === "accentSoft",
        id: "accentSoft",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset,
        onSetAsPrimaryColor: createSetPaletteAsPrimary("accentSoft")
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.grey,
        color: palette.grey,
        expanded: expanded === "grey",
        id: "grey",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.text,
        color: palette.text,
        expanded: expanded === "text",
        id: "text",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.action,
        color: palette.action,
        expanded: expanded === "action",
        id: "action",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset,
        renderExtraControl: (colorId) => {
          if (isKeyOfActionOpacity(colorId)) {
            return /* @__PURE__ */ jsx(ActionOpacities, { colorId, createOpacitySetter: createSetActionsOpacity, palette });
          }
          return null;
        }
      }
    ),
    /* @__PURE__ */ jsx(
      ColorPreview,
      {
        changedColor: previewPalette?.background,
        color: palette.background,
        expanded: expanded === "background",
        id: "background",
        onChangeColor: handleColorPropertyChange,
        onExpand: handleOnExpand,
        onReset: handleOnResetColor,
        onResetColor: handleColorPropertyReset
      }
    )
  ] });
}
export {
  Palette
};
//# sourceMappingURL=Palette.js.map
